import { defineStore } from 'pinia';
import axios from 'axios';
import { BACKEND_URL } from '../../../share-source/src/config/config.js'

export const useUserStore = defineStore('user', {
  state: () => ({
    user: null,
    authorities: [],
    isAuthenticated: false,
  }),
  
  actions: {
    async fetchUserInfo() {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/parent/current`, {});
        this.user = response.data;
        this.authorities = response.data.authorities || [];
        this.isAuthenticated = true;
      } catch (error) {
        console.error('Error fetching user info:', error);
        this.user = null;
        this.authorities = [];
        this.isAuthenticated = false;
      }
    },

    getStudentId() {
      return localStorage.getItem('currentStudent') || '0';
    },
    setStudentId(studentId) {
      localStorage.setItem('currentStudent', studentId);
    },  

    getNoticeSince(studentId) {
      return localStorage.getItem('NoticeSince' + studentId) || new Date(0);
    },
    setNoticeSince(studentId, since) {
      localStorage.setItem('NoticeSince' + studentId, since);
    },
    
    logout() {
      this.user = null;
      this.authorities = [];
      this.isAuthenticated = false;
    },

    getUserId() {
      return this.user.id;
    }
  },
  
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'user',
        storage: localStorage,
        paths: ['user', 'authorities', 'isAuthenticated']
      }
    ]
  }
}); 